import { useState, useEffect } from "react";
import "./ProjectSummary.css";
import axiosInstance from "../../../../Config/axiosInstance";

function ProjectSummary() {
  // State pentru datele de sumar:
  const [summaryData, setSummaryData] = useState({
    total: 0,
    active: 0,
    completed: 0,
  });

  // State pentru a controla afișarea skeleton-ului de loading
  const [loading, setLoading] = useState(true);

  // Se execută o singură dată la montarea componentei
  useEffect(() => {
    fetchSummaryData();

    // Funcție care reîncarcă datele când este emis evenimentul custom
    const handleProjectsUpdated = () => {
      fetchSummaryData();
    };

    // Adaugă listener global pentru refresh automat
    window.addEventListener("projectsUpdated", handleProjectsUpdated);

    // Cleanup: elimină listenerul la demontarea componentei
    return () => {
      window.removeEventListener("projectsUpdated", handleProjectsUpdated);
    };

  }, []);

  // Funcție asincronă pentru apelul API
  const fetchSummaryData = async () => {


    try {
      setLoading(true);

      // Request GET către backend pentru sumar
      const response = await axiosInstance.get("/code_registries/summary/");

      // Protecție în caz că response.data este undefined/null
      const data = response.data || {};

      // Actualizează state-ul cu valori numerice sigure
      setSummaryData({
        total: Number(data.total) || 0,
        active: Number(data.active) || 0,
        completed: Number(data.completed) || 0,
      });

    } catch (error) {
      // Loghează eroarea în consolă      
      console.error("Error loading project summary:", error);

    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="project-summary">
        <div className="summary-skeleton"></div>
      </div>
    );
  }

  return (
    <div className="project-summary">
      {/* TOTAL PROJECTS */}
      <div className="summary-item">
        <span className="summary-dot total-dot"></span>

        <div className="summary-content">
          <span className="summary-label">
            Total Project
          </span>
          <span className="summary-value">{summaryData.total}</span>
        </div>
      </div>

      <div className="summary-divider"></div>

      {/* ACTIVE PROJECTS */}
      <div className="summary-item">
        <span className="summary-dot active-dot"></span>
        <div className="summary-content">
          <span className="summary-label">Active</span>
          <span className="summary-value">{summaryData.active}</span>
        </div>
      </div>

      <div className="summary-divider"></div>

      <div className="summary-item">
        <span className="summary-dot completed-dot"></span>
        {/* Bulină pentru completed */}
        <div className="summary-content">
          <span className="summary-label">Completed</span>
          <span className="summary-value">{summaryData.completed}</span>
        </div>
      </div>
    </div>
  );
}

export default ProjectSummary;